<template>
  <modal name="modal-delivery" ref="modalDelivery">
    <template v-if="showModalDelivery && show">
      <p slot="header" style="text-decoration: underline">
        Умови та вартість доставки
      </p>
      <div slot="content">
        <section class="container" style="font-family: Roboto,sans-serif;background: white; width: unset;">
          <div class="delivery col-md-10 col-xs-12"
               v-if="currentPartner && currentPartner.schedule.delivery_conditions"
               v-html="currentPartner.schedule.delivery_conditions"/>
        </section>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../../../core/Modal";
import { mapGetters } from 'vuex'
export default {
  name: "DeliveryModal",
  components: {
    Modal
  },
  props: {
    showModalDelivery: {
      type: false,
      required: false
    }
  },
  computed: {
    show () {
      if (this.$refs.modalDelivery.isVisible) {
        return this.$refs.modalDelivery.isVisible
      }
      return false
    },
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner'
    })
  }
}
</script>

<style  scoped>
  .delivery {
    width: 100%;
    margin: 20px auto;
  }
  .delivery >>> ul {
    text-align: left;
    list-style: none;
    font-family: 'TTNorms Light', sans-serif;
    width: 100%;
    text-decoration: none;
    font-size: 16px;
  }
  .delivery >>> li {
    font-size: 14px;
    padding-left: 7px;
    padding-top: 10px;
  }
  .delivery >>> li::before {
    content: "";
    background-color: #11bb2e;
    display: inline-block;
    font-size: 35px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-left: -14px;
    margin-right: 5px;
    margin-bottom: 2px;
  }
</style>
